import $ from 'jquery';
import _ from 'lodash';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/src/js/ui/photoswipe-ui-default';

import 'foundation-sites';
import 'slick-carousel';

import './scss/app.scss';

Foundation.Drilldown.defaults.backButton = '<li class="js-drilldown-back"><a tabindex="0">Terug</a></li>';

$(document).foundation();

$(document).ready(function () {
  // Initialize sliders
  $('[data-slick]').slick({
    arrows: false,
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    infinite: true,
    initialSlide: 12,
    slidesToShow: 5,
    swipeToSlide: true,
    variableWidth: true
  });

  // Set up lazy loading
  $('img.lazy').lazy({effect: 'fadeIn', effectTime: 100});

  // Add filtering
  $('input[data-filter]').each(function (idx, searchField) {
    const target = '#' + $(searchField).data('filter');
    const elements = $(target).children();
    const sortedElements = _.sortBy(elements, [element => $(element).find('h2').text()]);

    const updateQuery = function (event) {
      // Reset to the original state and remove the elements from the DOM so either the sorted or the regular list can
      // be inserted. The diffing would be handled by a view framework, but, yeah...
      elements.detach();
      elements.show();
      elements.removeAttr('aria-hidden');

      // Filtered results should be sorted, otherwise the original (random) order should be used
      const query = _.escapeRegExp($(searchField).val()).replace(' ', '.*');
      if (query === '') {
        return $(target).append(elements);
      }

      const regex = new RegExp(query, 'i');
      const matches = elements.filter((idx, element) => !$(element).find('h2').text().match(regex));
      matches.hide();
      matches.attr('aria-hidden', true);

      $(target).append(sortedElements);
    };

    updateQuery();
    $(searchField).keydown(_.debounce(updateQuery, 200));
  });

  // Initialize galleries
  const photos = $('[data-lightbox]');
  if (photos.length > 0) {
    const gallery = photos.map((_, photo) => JSON.parse(photo.dataset.lightbox));
    const pswpElement = $('.pswp')[0];

    photos.click(function (event, y) {
      event.preventDefault();
      event.stopPropagation();

      const index = photos.index(event.currentTarget);
      const photoswipe = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, gallery, {
        index: index,
        getThumbBoundsFn: function (index) {
          const element = $(photos[index]);
          const offset = (element.is('img') ? element : element.find('img')).offset();

          return {x: offset.left, y: offset.top, w: element.width()};
        },
        showHideOpacity: true,
        bgOpacity: 0.95
      });
      photoswipe.init();
    });
  }
});



// WEBPACK FOOTER //
// ./entry.js